<!-- mips-gauges.component.html -->
<div class="mips-gauges-container">
  <div class="gauge-cards-container">
    <ng-container *ngFor="let gauge of gauges; let i = index" class="gauge-card">
      <mat-card-content [matTooltip]="getTooltipText(gauge)" [matTooltipPosition]="'below'" [matTooltipClass]="'multiline-tooltip'">
        <h2 class="gauge-title">{{ gauge.title }}</h2>

        <ng-container *ngIf="gauge.isReweighted && gauge.max === 0; else showGauge">
          <div class="reweighted-placeholder">
            <mat-icon class="reweighted-icon">swap_horiz</mat-icon>
            <p class="reweighted-label">Reweighted</p>
            <p class="reweighted-note">Weight redistributed to other categories</p>
          </div>
        </ng-container>

        <ng-template #showGauge>
          <ngx-gauge
            [value]="gauge.value"
            [label]="''"
            [append]="''"
            [markers]="getMarker(gauge)"
            [min]="gauge.min"
            [max]="gauge.max"
            [thick]="15"
            [margin]="20"
            [foregroundColor]="gauge.color">
          </ngx-gauge>
        </ng-template>

        <div class="reweight-toggle-container" *ngIf="gauge.showReweightToggle">
          <mat-slide-toggle
            [checked]="gauge.isReweighted"
            (change)="onToggleReweight(gauge)"
            class="reweight-toggle">
            Reweight
          </mat-slide-toggle>
        </div>
      </mat-card-content>
    </ng-container>
  </div>

  <div class="actions-container">
    <button *ngIf="false" mat-raised-button color="primary" class="set-goals-button">
      SET GOALS
    </button>
  </div>
</div>
